<template>
  <div class="index-homepage-mobile" :style="{ height: (contenitoreHeight) + 'px' }" v-if="country !== ''">
    <!--<header-app :counterNuovi="counterNuovi"></header-app>-->
    <div>
      <div class="contenitore col-24 padding-mobile" :style="{ height: (contenitoreHeight) + 'px' }">

        <div class="row row-custom testata">
          <div class="card-testata col-24 no-padding">
            <dashboard-card-doppia :properties="utente"></dashboard-card-doppia>
          </div>
        </div>


        <!-- Prospetto FERIE FRANCIA e ASSENTESIMO SPAGNA, BELGIO E ITALIA -->
        <div class="row row-custom">
          <div class="col-24 no-padding">
            <prospetto-assenze :codLang="codLang"></prospetto-assenze>
            <!--<prospetto-assenze1 v-if="country === '1'"></prospetto-assenze1>
            <prospetto-assenze2 v-if="country === '2'"></prospetto-assenze2>
            <prospetto-assenze3 v-if="country === '3'"></prospetto-assenze3>
            <prospetto-assenze4 v-if="country === '4'"></prospetto-assenze4>
            <prospetto-assenze5 v-if="country === '5'"></prospetto-assenze5>--> 
          </div>
        </div>

        <!-- CM Ultimo Mese ITALIA, FRANCIA, SPAGNA e GERMANIA-->
        <div class="row row-custom">
          <div class="col-24 no-padding">
            <content-manager :properties="cmUltimoMese" :contenitoreHeight="320"></content-manager>
          </div>
        </div>

        <!-- Carousel Pictures-->
        <div class="row row-custom">
          <div class="col-24 no-padding">
            <carousel-pictures :contenitoreHeight="500" :loadingImg="loading" :images="dsh_CAI"></carousel-pictures>
          </div>
        </div>

        <!-- Carousel Video-->
        <div class="row row-custom">
          <div class="col-24 no-padding">
            <carousel-video :contenitoreHeight="280" :loadingImg="loading" :images="dsh_CAV"></carousel-video>
          </div>
        </div>

      </div>

    </div>
  </div>

</template>

<script>
import moment from 'moment'
import DashboardCardDoppia from '../ServiceComponents/DashboardCardDoppia.vue'
import DashboardCard from '../ServiceComponents/DashboardCard.vue'
import { bus } from '../Bus.js'
import Links from './LinkUtili.vue'
import CarouselPictures from './CarouselPictures'
import CarouselVideo from './CarouselVideo'
import ContentManager from './ContentManager.vue'
/*import ProspettoAssenze1 from './ProspettoAssenze1.vue'
import ProspettoAssenze2 from './ProspettoAssenze2.vue'
import ProspettoAssenze3 from './ProspettoAssenze3.vue'
import ProspettoAssenze4 from './ProspettoAssenze4.vue'
import ProspettoAssenze5 from './ProspettoAssenze5.vue'*/
import ProspettoAssenze from './ProspettoAssenze.vue'

export default {
  components: {
    Links,
    DashboardCard,
    DashboardCardDoppia,
    CarouselPictures,
    CarouselVideo,
    ContentManager,
    /*ProspettoAssenze1,
    ProspettoAssenze2,
    ProspettoAssenze3,
    ProspettoAssenze4,
    ProspettoAssenze5,*/
    ProspettoAssenze
  },
  props: {
    area: {
      type: String,
      default: 'documenti'
    },
    contenitoreHeight: {
      type: Number
    }
  },
  name: 'DashBoardMobile',
  i18n: {
    messages: {
      it_IT: {
        dashboard: {
          days: {
            0: 'Domenica',
            1: 'Lunedì',
            2: 'Martedì',
            3: 'Mercoledì',
            4: 'Giovedì',
            5: 'Venerdì',
            6: 'Sabato'
          },
          user: 'Nome Utente',
          soc: 'Società',
          lastAccess: 'Ultimo Accesso',
          recapiti: 'Recapiti',
          cards_ferie: {
            des_0: 'Ferie Residue',
            des_1: 'Ferie Richieste',
            des_2: 'Roll Residuo',
            des_3: 'Roll Richiesto',
            d: 'Giorni',
            h: 'Ore'
          },
          timb: 'Timbrature',
          entrata: 'Entrata',
          uscita: 'Uscita',
          manuali: {
            titolo: 'Manuali',
            utente_v1: 'Manuale Utente',
            utente_v2: 'Revisione Ott. 2019'
          },
          contentManager: {
            titoloUtimoMese: 'Ultimo Mese'
          },
          msg: {},
          btn: {}
        }
      },
      fr_FR: {
        dashboard: {
          days: {
            0: 'Dimanche',
            1: 'Lundi',
            2: 'Mardi',
            3: 'Mercredi',
            4: 'Jeudi',
            5: 'Vendredi',
            6: 'Samedi'
          },
          user: 'Identifiant',
          soc: 'Société',
          lastAccess: 'Dernier accès',
          recapiti: 'Contacts',
          cards_ferie: {
            des_0: 'Congé Résiduelles',
            des_1: 'Congé Requises',
            des_2: 'RCR Résiduelles',
            des_3: 'RCR Requises',
            d: 'Jours',
            h: 'Heure'
          },
          timb: 'Timbrature',
          entrata: 'Entrée',
          uscita: 'Sortie',
          manuali: {
            titolo: 'Manuels',
            utente_v1: 'Portail Employes.',
            utente_v2: 'Révision Oct. 2019'
          },
          contentManager: {
            titoloUtimoMese: 'Documents Paie du Mois'
          },
          msg: {},
          btn: {}
        }
      },
      es_ES: {
        dashboard: {
          days: {
            0: 'Domingo',
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sábado'
          },
          user: 'Personal',
          soc: 'Empresa',
          lastAccess: 'Último acceso',
          recapiti: 'Contactos',
          cards_ferie: {
            des_0: 'Congé Résiduelles',
            des_1: 'Congé Requises',
            des_2: 'RCR Résiduelles',
            des_3: 'RCR Requises',
            d: 'Jours',
            h: 'Heure'
          },
          timb: 'Timbrature',
          entrata: 'Entrée',
          uscita: 'Sortie',
          manuali: {
            titolo: 'Manuales',
            utente_v1: 'Portal de Trabajador.',
            utente_v2: 'Revisado oct. 2019'
          },
          contentManager: {
            titoloUtimoMese: 'Mes Actual'
          },
          msg: {},
          btn: {}
        }
      },
      de_DE: {
        dashboard: {
          days: {
            0: 'Sonntag',
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Samstag'
          },
          user: 'Benutzername',
          soc: 'Firma',
          lastAccess: 'Letzter Zugriff',
          recapiti: 'Kontaktdaten',
          cards_ferie: {
            des_0: 'Ferie Residue',
            des_1: 'Ferie Richieste',
            des_2: 'Roll Residuo',
            des_3: 'Roll Richiesto',
            d: 'Giorni',
            h: 'Ore'
          },
          timb: 'Timbrature',
          entrata: 'Entrata',
          uscita: 'Uscita',
          manuali: {
            titolo: 'Anleitungen',
            utente_v1: 'Benutzerhandbuch',
            utente_v2: 'Revision Okt. 2019'
          },
          contentManager: {
            titoloUtimoMese: 'Dokumente im letzten Monat'
          },
          msg: {},
          btn: {}
        }
      },
      en_GB: {
        dashboard: {}
      }
    }
  },
  data() {
    return {
      codLang: '',
      loading: false,
      showScroll: true,
      menuApps: [],
      menu: {},
      apps: [],
      areaProva: this.area,
      country: '',
      utente: {
        bgColorUp: 'linear-gradient(to left, #AC237F, #E67BC4 )',
        bgColorDown: 'linear-gradient(to left, #7D3D87, #C966C2 )',
        iconColorUp: '#ffffff',
        iconColorDown: '',
        titleUp: '',
        titleDown: '',
        iconaUp: 'riv-user2',
        iconaDown: '',
        typeUp: 'Info',
        typeDown: 'Title',
        value1Up: '',
        value2Up: '',
        valueDown: ''
      },
      societa: {
        bgColor: '#7d3d87',
        iconColor: '#d26eb2',
        title: '',
        icona: '',
        type: 'Info',
        value1Up: '',
        value2Up: ''
      },
      manuale_utente: {
        bgColor: '#fff',
        borderColor: '#e7e7e7',
        iconColor: '#d20b07',
        iconPosition: 'right',
        color: '#585c60',
        title: '',
        icona: 'riv-pdf_RGB',
        type: 'manual',
        value1Up: '',
        value2Up: '',
        url: './static/docs/Portail Employes.pdf'
      },
      lastAccess: {
        bgColor: '#485eb5',
        iconColor: '#9fa9d1',
        title: '',
        icona: 'riv-calendar3',
        type: 'Info',
        value1Up: '',
        value2Up: ''
      },
      recapiti: {
        bgColorUp: '#bd3090',
        bgColorDown: '#8a2068',
        iconColorUp: '',
        iconColorDown: '#d692c1',
        titleUp: '',
        titleDown: '',
        iconaUp: '',
        iconaDown: 'riv-phone2',
        typeUp: '',
        typeDown: '',
        value1Up: '',
        value2Up: '',
        valueDown: ''
      },
      cmUltimoMese: {
        compressa: true,
        bgColor: '#fff',
        border: 'none',
        borderRadius: '4px',
        icona: 'riv-cal10',
        iconColor: '#e7e7e7',
        title: '',
        url: 'ultMese',
        numSchede: '6'
      },
      // servizio dashboard
      dsh_CAV: [],
      dsh_CAI: [],
      dsh_ANN: [],
      dsh_ULT: [],
      dsh_INF: []
    }
  },
  watch: {
    '$route.meta.appName': function (to, from) {
      if (!this._inactive)
        this.initialize()
    }
  },
  mounted: function () {
    this.country = this.$store.state.country
  },
  activated: function () {
    this.country = this.$store.state.country
    this.initialize()
  },
  deactivated: function () {
  },
  methods: {
    initialize: function () {
      this.codLang = sessionStorage.getItem('codLang')
      let lastAccess = this.$store.state.lastAccess
      if (lastAccess !== '' && lastAccess !== undefined) {
        let acc = ""
        acc = lastAccess.substr(6, 2) + '/' + lastAccess.substr(4, 2) + '/' + lastAccess.substr(0, 4) + ' ' + lastAccess.substr(8, 2) + ':' + lastAccess.substr(10, 2)
        this.$set(this.utente, 'valueDown', acc)
      }
      this.$set(this.utente, 'value1Up', this.$store.state.nomex)
      this.$set(this.utente, 'value2Up', this.$store.state.cognx)
      this.getMessaggi()
      //this.getInfo()
      this.$nextTick(() => {
        this.utente.titleDown = this.$t('dashboard.lastAccess')
        /*this.societa.title = this.$t('dashboard.soc')
        this.lastAccess.title = this.$t('dashboard.lastAccess')
        this.recapiti.titleUp = this.$t('dashboard.recapiti')
        this.manuale_utente.title = this.$t('dashboard.manuali.titolo')
        this.manuale_utente.value1Up = this.$t('dashboard.manuali.utente_v1')
        this.manuale_utente.value2Up = this.$t('dashboard.manuali.utente_v2')*/
        this.cmUltimoMese.title = this.$t('dashboard.contentManager.titoloUtimoMese')
        bus.$off('changeLanguage')
        bus.$on('changeLanguage', () => {
          this.codLang = sessionStorage.getItem('codLang')
          this.$nextTick(() => {
            this.utente.titleDown = this.$t('dashboard.lastAccess')
            /*this.societa.title = this.$t('dashboard.soc')
            this.lastAccess.titleUp = this.$t('dashboard.lastAccess')
            this.recapiti.title = this.$t('dashboard.recapiti')
            this.manuale_utente.title = this.$t('dashboard.manuali.titolo')
            this.manuale_utente.value1Up = this.$t('dashboard.manuali.utente_v1')
            this.manuale_utente.value2Up = this.$t('dashboard.manuali.utente_v2')*/
            this.cmUltimoMese.title = this.$t('dashboard.contentManager.titoloUtimoMese')
          })
        })
      })
    },
    getDate: function () {
      let date = moment()
      return this.$i18n.t('dashboard.days.' + date.day()) + ' ' + date.format('D') + ' ' + this.$i18n.t('el.datepicker.month' + date.format('M')) + ' ' + date.format('YYYY')
    },
    getInfo: function () {
      this.$set(this.utente, 'value1Up', this.$store.state.nomex)
      this.$set(this.utente, 'value2Up', this.$store.state.cognx)
      this.$set(this.utente, 'valueDown', this.$store.state.user)
      this.$set(this.societa, 'value1Up', this.$store.state.localita)
      this.$set(this.societa, 'value2Up', this.$store.state.desSoc)
      this.$set(this.recapiti, 'valueUp', this.$store.state.mail)
      this.$set(this.recapiti, 'valueDown', this.$store.state.tel1)
    },
    getMessaggi: function () {
      this.$set(this, 'dsh_CAV', [])
      this.$set(this, 'dsh_CAI', [])
      this.$set(this, 'dsh_ANN', [])
      this.$set(this, 'dsh_ULT', [])
      this.$set(this, 'dsh_INF', [])
      this.loading = true
      let obj = {
        params: {
          tipo: 'CAI,CAV,ANN,ULT,INF'
        }
      }
      this.$http.get('dashboard/' + this.$store.state.country + '/messaggi', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'dsh_CAV', response.body.data.CAV === undefined ? [] : response.body.data.CAV)
            this.$set(this, 'dsh_CAI', response.body.data.CAI === undefined ? [] : response.body.data.CAI)
            this.$set(this, 'dsh_ANN', response.body.data.ANN === undefined ? [] : response.body.data.ANN)
            this.$set(this, 'dsh_ULT', response.body.data.ULT === undefined ? [] : response.body.data.ULT)
            this.$set(this, 'dsh_INF', response.body.data.INF === undefined ? [] : response.body.data.INF)
            bus.$emit("load_dsh_INF", this.dsh_INF)
          }
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.index-homepage-mobile {
  height: 100%;

  .titolo-app {
    padding-left: 5px;
    .set-font(@size: 15px; @color: @greenRiva);
    text-transform: uppercase;
    letter-spacing: 2px;
    overflow: hidden;
    height: 50px;
    line-height: 50px;

    .titolo-bold {
      font-weight: 700;
    }
  }

  .title {
    height: 60px;
    line-height: 60px;
    position: relative;
    cursor: pointer;
    padding-top: 15px;
    padding-bottom: 15px;
    display: block;
    text-align: center;
    letter-spacing: 3px;
    text-transform: uppercase;
    .set-font(@size: 16px, @color: @oroRiva, @weight: bold, @family: 'os-regular');
    //height: 50px;
    //padding-top: 15px;
    padding: 0;
    padding-right: 10px;
    // padding-top: 10px;
    // padding-bottom: 10px;
  }

  .testata {
    .card-testata {
      margin-bottom: 10px;
    }
  }

  .centrale {
    margin-bottom: 10px;

    .dash-box {
      // height: 100%;
      overflow: auto;
      border: 1px solid #e7e7e7;
      border-radius: 4px;
      -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
      box-shadow: 0px 0px 13px 1px #e7e7e7;
      padding: 10px;
    }

    .pictures {
      img {
        width: 100%;
      }
    }
  }

  .card-timb {
    height: 100%;
    width: 100%;
    display: inline-block;
    margin-bottom: 6px;
    background: url("/static/img/time-left.svg") no-repeat left;
    background-position-y: 150px;
    background-position-x: -15px;
    background-size: 100px 100px;
    //min-height: 44px;
    background-color: white;

    .scheda {
      width: 100%;
      height: 226px;
      margin-bottom: 6px;
      border: 1px solid #e7e7e7;
      border-radius: 4px;
      // -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
      // -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
      // box-shadow: 0px 0px 13px 1px #e7e7e7;
      margin: auto;
      text-align: center;

      .scheda-label {
        margin-top: 8px;
        text-transform: uppercase;
        height: 30px;
        line-height: 16px;
        .set-font(@size: 14px; @color: #48adb5);
        text-align: left;
        padding-left: 15px;
      }

      .scheda-int {
        line-height: 40px;
        height: 40px;
        margin-left: 20px;
        margin-right: 20px;
        border-bottom: 1px solid #bd3090;
        .set-font(@size: 14px; @color: #bd3090; @family: 'os-semibolditalic');
      }

      .scheda-body {
        margin-left: 20px;
        margin-right: 20px;
        height: 100px;

        span {
          display: block;
          margin-top: 10px;
          margin-bottom: 10px;
          .set-font(@size: 16px; @color: #3f2a6d);
          line-height: 30px;
        }
      }

      /*.scheda-label {
          .set-font(@size: 12px; @color: #bd3090);
        }*/
      .scheda-tipo {
        margin-top: 10px;
        text-transform: uppercase;
        .set-font(@size: 12px; @color: #3f2a6d);
      }
    }
  }

  /*.mid-left {
      height: 232px;
      .card-ferie {
        height: 48%;
        width: 50%;
        display: inline-block;
        margin-bottom: 6px;
        .scheda {
          border: 1px solid #e7e7e7;
          border-radius: 4px;
          // -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
          // -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
          // box-shadow: 0px 0px 13px 1px #e7e7e7;
          width: 96%;
          margin: auto;
          height: 110px;
          text-align: center;
          .scheda-label {
            margin-top: 8px;
            text-transform: uppercase;
            height: 24px;
            line-height: 16px;
            .set-font(@size: 14px; @color: #bd3090);
          }
          .scheda-valore {
            margin-top: 6px;
            .set-font(@size: 33px; @color: #48adb5);
            line-height: 30px;
          }
          .scheda-tipo {
            margin-top: 10px;
            text-transform: uppercase;
            .set-font(@size: 12px; @color: #3f2a6d);
          }
        }
      }
    }*/
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/DashBoardMobile.vue